import React, { useEffect, useState } from 'react';
import OrganizationIcon from '../../Assets/General/SettingPageIcon';
import { OrganizationForm } from '../../Components/Form';
import { FormLayout } from '../../Components';
import useToggleClick from '../../Hooks';
import { Prompt } from 'react-router-dom';
import './EditOrganization.css';
import { useTranslation } from 'react-i18next';

const EditOrganization = ({ handleToast }) => {
  const { t } = useTranslation();
  const [showPrompt, setPrompt] = useState(false);
  const [, handleCrossAlert] = useToggleClick();
  useEffect(() => {
    document.title = t('Settings.update_business');
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  const handlePrompt = (status = true) => setPrompt(status);

  return (
    <>
      <Prompt
        when={showPrompt}
        message={t("common.leave_page_warning")}
      />
      <FormLayout
        title={t('Settings.business')}
        Icon={OrganizationIcon}
        subtitle={t('Settings.edit_business')}
        closeUrl="/oc/organization/choose"
        layoutBoxClass="uiux-form-redesign"
      >
        <OrganizationForm
          type="Edit"
          handleToast={handleToast}
          handleCrossAlert={handleCrossAlert}
          setPrompt={handlePrompt}
        />
      </FormLayout>
    </>
  );
};

export default EditOrganization;
